module.exports = __webpack_public_path__ + "static/media/bg-2.50f0845a.png";